import { render, staticRenderFns } from "./AdminAuditLog.vue?vue&type=template&id=052e8372&scoped=true"
import script from "./AdminAuditLog.vue?vue&type=script&lang=js"
export * from "./AdminAuditLog.vue?vue&type=script&lang=js"
import style0 from "./AdminAuditLog.vue?vue&type=style&index=0&id=052e8372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e8372",
  null
  
)

export default component.exports